//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { WebsiteBlockType } from './Enums';

export abstract class WebsiteBlockInputItem extends ItemBase {
    OrderIndex: number = 0;
    abstract readonly WebsiteBlockType: WebsiteBlockType;

    static readonly ClassName: string = "WebsiteBlockInputItem";
}
